import React from 'react';
import { Check, Clock, X } from 'lucide-react';

const THEMES = {
  employee: {
    completed: 'bg-blue-800 text-white shadow-sm',
    current: 'bg-blue-800 text-white shadow-sm ring-4 ring-blue-200',
    rejected: 'bg-red-600 text-white shadow-sm',
    upcoming: 'bg-gray-200 text-gray-500',
    connectorDone: 'bg-blue-800',
    labelCompleted: 'text-blue-800 font-medium',
    labelCurrent: 'text-blue-800 font-semibold',
    labelRejected: 'text-red-600 font-semibold',
    labelUpcoming: 'text-gray-500',
  },
  admin: {
    completed: 'bg-red-600 text-white shadow-sm',
    current: 'bg-red-600 text-white shadow-sm ring-4 ring-red-200',
    rejected: 'bg-red-600 text-white shadow-sm',
    upcoming: 'bg-gray-200 text-gray-500',
    connectorDone: 'bg-red-600',
    labelCompleted: 'text-red-700 font-medium',
    labelCurrent: 'text-red-700 font-semibold',
    labelRejected: 'text-red-600 font-semibold',
    labelUpcoming: 'text-gray-500',
  },
};

const ICONS = {
  completed: Check,
  current: Clock,
  rejected: X,
  upcoming: Clock,
};

/**
 * Read-only horizontal progress rail. Not clickable, no percentage.
 */
const ProcessProgressRail = ({
  title = 'Progress',
  steps = [],
  theme = 'employee',
  pendingWith = '',
}) => {
  const palette = THEMES[theme] || THEMES.employee;
  if (!steps.length) return null;

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
      <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-4">
        {title}
      </h4>
      <div className="flex items-start" aria-hidden="true">
        {steps.map((step, index) => {
          const state = step.state || 'upcoming';
          const Icon = ICONS[state] || Clock;
          return (
            <React.Fragment key={step.key || index}>
              <div className="flex flex-col items-center min-w-0">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-200 ${palette[state]}`}
                  title={step.subtitle || step.label}
                >
                  <Icon className="w-5 h-5" />
                </div>
                <span className={`text-xs mt-2 text-center max-w-[72px] leading-tight ${
                  state === 'completed' ? palette.labelCompleted
                    : state === 'current' ? palette.labelCurrent
                      : state === 'rejected' ? palette.labelRejected
                        : palette.labelUpcoming
                }`}
                >
                  {step.label}
                </span>
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`flex-1 h-1 rounded-full mx-2 mt-[18px] transition-all duration-200 ${
                    state === 'completed' ? palette.connectorDone : 'bg-gray-200'
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
      {pendingWith && (
        <p className="text-xs text-gray-500 mt-3 text-center">
          Waiting on: <span className="font-medium text-gray-700">{pendingWith}</span>
        </p>
      )}
    </div>
  );
};

export default ProcessProgressRail;
